import { render } from "./FaceAnimation.vue?vue&type=template&id=2ada530b"
import script from "./FaceAnimation.vue?vue&type=script&lang=js"
export * from "./FaceAnimation.vue?vue&type=script&lang=js"

import "./FaceAnimation.vue?vue&type=style&index=0&id=2ada530b&lang=scss"
script.render = render

export default script